module.exports = __webpack_public_path__ + "img/hardware@2x.e6542d17.png";